export const validateImage = (file) => new Promise((resolve, reject) => {
    if (/^image\/(png|jpeg|gif)$/.test(file.type)) {
        resolve(file);
        return;
    }
    reject('File is not image');
});
